import * as React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process, State, DataResult } from "@progress/kendo-data-query"
import "@progress/kendo-theme-material/dist/all.css";
import {
    ApprovedIcon,
    NotApprovedIcon
} from "../../../../_uiComponents/common/DataGridComponents";
import { Button } from "@progress/kendo-react-buttons";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from "@mui/material/Tooltip";
import {UiSingleSwitch} from '../../../../_uiComponents/telerikComponents/UiSwitch';
import UiSelect from "../../../../_uiComponents/common/form/UiSelectDefault";


const products = [
    {
        id: 1,
        area: "17",
        manager: 'Shoun Hennry',
        status: true,
    },
    {
        id: 2,
        area: "18",
        manager: 'Shoun Hennry',
        status: true,
    },
    {
        id: 3,
        area: "19",
        manager: 'Shoun Hennry',
        status: true,
    }


]

const initialDataState = {
    skip: 0,
    take: 3,
};

const initialSort = [
    {
        field: "area",
        dir: "asc",
    },
];

const AreaManagementGrid = () => {
    const [page, setPage] = React.useState(initialDataState);
    const [sort, setSort] = React.useState(initialSort);
    const [userType, setUserType] = React.useState("0");
    const [pageSizeValue, setPageSizeValue] = React.useState();
    const [dataState, setDataState] = React.useState();
    const [resultState, setResultState] = React.useState(
        process(products, initialDataState)
    );



    const pageChange = (event) => {
        const targetEvent = event.targetEvent;
        setResultState(process(products, event.page.skip, event.page.take));
        const take =
            targetEvent.value === "All" ? products.length : event.page.take;
        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take,
        });
    };

    const onDataStateChange = React.useCallback((e) => {
        setDataState(e.dataState);
        setSort(e.sort);
        setResultState(process(products, e.dataState));

    }, []);

    const StatusCell = (props) => {
        const [checked, setChecked] = React.useState(false);

        const handleChange = (event) => {
            setChecked(event.target.value);
        };

        return (
            <td
                {...props.tdProps}
            >
                <UiSingleSwitch handleChange={handleChange} checked={checked}/>
            </td>
        );
    };
    

    const ActionArea = (props) => {

        const viewChange = (item) =>{
            console.log(item)
        }
        const editChange = (item) =>{
            console.log(item)
        }
        const deleteChange = (id) =>{
            console.log(id)
        }

        return (
            <td
                {...props.tdProps}
            >
                <div className="sbt-data-grid__action-bar">
                    <Tooltip
                        title="View"
                        placement="top"
                        arrow
                    >
                        <IconButton
                            aria-label="View"
                            
                            sx={{
                                ml: 1.5,
                            }}
                            onClick={()=> viewChange(props.dataItem)}
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </Tooltip>
                  
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                        <IconButton
                            aria-label="Edit"                           
                            sx={{
                                ml: 1.5,
                            }}
                            onClick={()=> editChange(props.dataItem)}
                        >
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        title="Delete"
                        placement="top"
                        arrow
                    >
                        <IconButton                          
                            aria-label="delete"
                            sx={{
                                ml: 0.5,
                            }}
                            onClick={()=> deleteChange(props.dataItem.id)}
                        >
                            <DeleteIcon color="error" />
                        </IconButton>
                    </Tooltip>
                </div>

            </td>
        );
    };
    
    const options = [
        { value: "0", label: "All" },
        { value: "1", label: "Equipe" },
        { value: "3", label: "TLC" },
   ];

    return (
        <div className='sba-telerik-components-wr'>
               <div className="sba-chart-section-top-search">
                    <UiSelect
                         options={options}
                         value={userType}
                         // handleChange={(value) =>
                         //      getApplicationTypeInitialData(value)
                         // }
                    />
               </div>
            <Grid
                data={resultState.data.slice(page.skip, page.take + page.skip)}
                skip={page.skip}
                take={page.take}
                total={products.length}
                sortable={true}
                fixedScroll={true}
                className="sba-area-data-grid"
                sort={sort}
                pageable={{
                    buttonCount: 4,
                    pageSizes: [5, 10, 15, "All"],
                    pageSizeValue: pageSizeValue,
                }}
                {...dataState}
                onPageChange={pageChange}
                onDataStateChange={onDataStateChange}

            >
                <GridColumn field="area" title="Area" width="200px" />
                <GridColumn field="manager" title="Manager" width="200px" />
                <GridColumn field="status" title="Status" width="150px" cells={{
                    data: StatusCell
                }} />
                <GridColumn cells={{
                    data: ActionArea
                }} width="250px" />
            </Grid>
        </div>
    );
};
export default AreaManagementGrid;
